import { usePerfilesContext } from '@conductor/context/PerfilesContext';
import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
// import { useNotificaciones } from './useNotificaciones';
import { useAuth } from '@conductor/context/AuthContext';
import socketConfig from '@shared/config/services/socket.config';
import { useNotify } from '@conductor/context/NotifyContext';


const SocketContext = createContext({
  socket: null,
  emit: () => { },
});

export const SocketProvider = ({ children }) => {
  const { userData } = useAuth();
  const { perfil } = usePerfilesContext();
  const [socket, setSocket] = useState(null);
  const { fetchNotificaciones } = useNotify();

  useEffect(() => {
    if (!perfil || !userData) return;
    const config = {
      path: socketConfig.PATH,
      withCredentials: true,
      transports: socketConfig.TRANSPORTS,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 10,
      auth: {
        id: userData.id,
        profile: perfil,
        user_id: userData.idUser
      },
    };
    const socket = io(socketConfig.URL, config);
    socket.on("connect", () => {
      console.log("⚡️ Socket conectado:", socket.id);
    });

    socket.on("notificacion", (data) => {
      if (userData.id !== data.userId) return; // Solo procesar notificaciones del usuario actual
      fetchNotificaciones();
    });

    socket.on("disconnect", reason => {
      console.warn("⚠️ Socket desconectado:", reason);
    });
    socket.on("connect_error", err => {
      console.error("❌ Error de conexión socket:", err.message);
    });
    socket.on("reconnect", attempt => {
      console.log("🔄 Socket reconectado en intento:", attempt);
    });

    setSocket(socket);
    return () => socket.disconnect();
  }, [perfil, userData, fetchNotificaciones]);

  const emit = (event, data) => {
    if (!socket) return console.warn("Emit antes de conectar:", event);
    socket.emit(event, data);
  };

  return (
    <SocketContext.Provider value={{ socket, emit }}>
      {children}
    </SocketContext.Provider>
  );
};



export const useSocket = (listeners = []) => {
  const { socket, emit } = useContext(SocketContext);

  useEffect(() => {
    if (!socket || !listeners.length) return;

    listeners.forEach(({ event, handler }) => {
      if (typeof handler === "function") {
        socket.on(event, handler);
      } else {
        console.warn(`Handler no válido para el evento "${event}":`, handler);
      };
    });
    return () => {
      listeners.forEach(({ event, handler }) => {
        if (typeof handler === "function") {
          socket.off(event, handler);
        };
      });
    };
  }, [
    socket,
    JSON.stringify(listeners.map(l => l.event)),
  ]);

  return { socket, emit };
};




/*
const { emit } = useSocket([
    {
        event: "inicio_viaje",
        handler: ({ status, message }) => {
            if (status) {
                getViajes({ dataUsuario: userData ?? dataUser })
                newToast(message, 'success')
            }
        }
    },
]);
*/